
const lightHouseArticles = {
  billing: 'byi38gwbc0',
  helpPage: 'iahfg7v3ev',
  checkout: 'xrg7438jj0',
  cameraTrouble: 'cye0o16o42',
  validVideo: '66wom3xp5p',
  reviewOrder: '7gt4d2vs3w',
  createOrder: 'ybspwsh101',
};

export default lightHouseArticles;
